import React, { Component } from 'react';
import { AlertCircle } from 'react-feather';
import "./ErrorBlockMessage.scss";

const ErrorBlockMessage = ({ children, style, className}) => {

	return (
		<div style={style} className={`error-block-message ${className ? className : ""}`}>
			<AlertCircle />
			<div className="error-block-text">
				{children ? children : "Error"}
			</div>
		</div>
	);
}

export default ErrorBlockMessage;